import { CMS_PAGE_ID } from "../enum/cms-page-id.enum";
import { STEP_ID } from "../enum/step-id.enum";

// stepId: 123, // usado para identificar o step do backend
// path: 'pagina-indisponivel', // usado para enviar ao monitoramento da aplicação (pageView do Google Analytics e Dynatrace)
// url: 'pagina-indisponivel', // usado para navegação do usuário, é o que aparece na URL do navegador
// showHeader: true, // controla exibição do cabeçalho na página
// cmsId:'123' // usado para recuperar os textos e imagens de cada página no resolver

var COMMON_FLOW = ['OPEN', 'CARD', 'MONO', 'FOPA','OPEN_OCCULT','FOPA_OCCULT']

export const ROUTES = {
    error: {
        flowName: COMMON_FLOW,
        stepId: null,
        path: "erro",
        url: "erro",
        showHeader: true,

    },

    errorAccountHolder: {
        flowName: COMMON_FLOW,
        stepId: null,
        path: "ja-possui-conta",
        url: "ja-possui-conta",
        showHeader: true,

    },

    accountOpen: {
        flowName: COMMON_FLOW,
        stepId: null,
        path: "proposta-aprovada",
        url: "proposta-aprovada",
        showHeader: true,

    },

    errorAccountRejected: {
        flowName: COMMON_FLOW,
        stepId: null,
        path: "conta-indisponivel",
        url: "conta-indisponivel",
        showHeader: true,

    },
    holderAdvice: {
        flowName: COMMON_FLOW,
        stepId: null,
        path: "aviso-correntista",
        url: "aviso-correntista",
        showHeader: true,
        cmsId: CMS_PAGE_ID.paginaAccountHolder,
    },
    errorAccountWarning: {
        stepId: null,
        path: 'aviso',
        url: 'aviso',
        showHeader: true,
        cmsId: CMS_PAGE_ID.pageError
    },
    errorGeneric: {
        flowName: COMMON_FLOW,
        stepId: null,
        path: "erro-de-servico",
        url: "erro-de-servico",
        showHeader: true,

    },

    errorOffline: {
        flowName: COMMON_FLOW,
        stepId: null,
        path: "erro-sem-conexao",
        url: "erro-sem-conexao",
        showHeader: true,

    },
    landing: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.IDENTIFY,
        path: "landing",
        url: "",
        cmsId: CMS_PAGE_ID.pageLanding,
    },

    identification: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.IDENTIFY,
        path: "identificacao",
        url: "identificacao",
        cmsId: CMS_PAGE_ID.pageIdentification,
    },

    client_name_view: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.CLIENT_NAME,
        path: "confirmar-nome",
        url: "confirmar-nome",
        cmsId: CMS_PAGE_ID.pageClientNameView,
    },

    client_name_edit: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.CLIENT_NAME,
        path: "mudar-nome",
        url: "mudar-nome",
        cmsId: CMS_PAGE_ID.pageClientNameEdit,
    },

    client_data: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.CLIENT_DATA,
        path: "dados-pessoais",
        url: "dados-pessoais",
        cmsId: CMS_PAGE_ID.pageClientData,
    },

    client_data_link: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.CLIENT_DATA_LINK,
        path: "dados-pessoais-link",
        url: "dados-pessoais-link",
        cmsId: CMS_PAGE_ID.pageClientDataLink,
    },

    client_address: {
        flowName: COMMON_FLOW,
        stepId: [STEP_ID.CLIENT_ADDRESS,STEP_ID.CLIENT_ADDRESS_LINK],
        path: "endereco",
        url: "endereco",
        cmsId: CMS_PAGE_ID.pageClientAddress,
    },

    token_validation: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.IDENTIFY,
        path: "token",
        url: "token",
        cmsId: CMS_PAGE_ID.pageToken,
    },

    identity_recovery: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.IDENTIFY,
        path: "status-conta-token",
        url: "status-conta-token",
        cmsId: CMS_PAGE_ID.pageIdentityRecovery,
    },

    identity_recovery_fix_mail: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FRAUD_EMAIL,
        path: "status-conta-email",
        url: "status-conta-email",
        cmsId: CMS_PAGE_ID.pageIdentityFixEmail,
    },

    step_secret_access: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.SECRET_ACCESS,
        path: "criar-senha",
        url: "criar-senha",
        cmsId: CMS_PAGE_ID.pageSecretAcces,
    },

    step_confirmation: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.CONFIRMATION,
        path: "confirmacao",
        url: "confirmacao",
        cmsId: CMS_PAGE_ID.pageConfirmation,
    },

    step_finish: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FINISH,
        path: "feedback",
        url: "feedback",
        cmsId: CMS_PAGE_ID.pageFinish,
    },

    fraude_face_biometry: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FRAUD_FACE,
        path: "biometria",
        url: "biometria",
        cmsId: CMS_PAGE_ID.pageFraudeFaceBiometry,
    },

    fraude_face_selfie: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FRAUD_SELFIE,
        path: "selfies",
        url: "selfies",
        cmsId: CMS_PAGE_ID.pageFraudeFaceSelfie,
    },

    fraude_face_selfie_capture: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FRAUD_SELFIE,
        path: "capturar-selfie",
        url: "capturar-selfie",
        cmsId: CMS_PAGE_ID.pageFraudeFaceSelfieCapture,
    },

    fraude_doc_documents: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FRAUD_DOC,
        path: "envio-de-documentos",
        url: "envio-de-documentos",
        cmsId: CMS_PAGE_ID.pageDocument,
    },

    fraude_doc_documents_capture: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FRAUD_DOC,
        path: "capturar-documento",
        url: "capturar-documento",
        cmsId: CMS_PAGE_ID.pageDocumentCapture,
    },

    fraude_doc_documents_viewer: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.FRAUD_DOC,
        path: "ver-documento",
        url: "ver-documento",
        cmsId: CMS_PAGE_ID.pageDocumentViewer,
    },

    offer_package: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_PACKAGE,
        path: "oferta",
        url: "oferta",
        cmsId: CMS_PAGE_ID.pageOfferPackage,
    },
    offer_package_link: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_PACKAGE,
        path: "oferta-link",
        url: "oferta-link",
        cmsId: CMS_PAGE_ID.pageOfferPackageLink,
    },
    offer_card_link: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_CARD_MATRIX,
        path: "cartao-link",
        url: "cartao-link",
        cmsId: CMS_PAGE_ID.pageOfferCardLink,
    },
    offer_card: {
        flowName: COMMON_FLOW,
        stepId: [STEP_ID.OFFER_CARD,STEP_ID.OFFER_CARD_LIST],
        path: "cartao",
        url: "cartao",
        cmsId: CMS_PAGE_ID.pageOfferCard,
    },
    offer_card_unified: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_CARD_MATRIX,
        path: "oferta-de-cartao-unificado",
        url: "oferta-de-cartao-unificado",
        cmsId: CMS_PAGE_ID.pageOfferCardLink,
    },

    offer_express_card: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_CARD_EXPRESS,
        path: "cartao-expresso",
        url: "cartao-expresso",
        cmsId: CMS_PAGE_ID.pageOfferExpressCard,
    },

    offer_card_flow: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_CARD_PACKAGE,
        path: "oferta-de-cartao",
        url: "oferta-de-cartao",
        cmsId: CMS_PAGE_ID.pageOfferCardFlow,
    },

    offer_scp: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_SCP,
        path: "seguro-cartao",
        url: "seguro-cartao",
        cmsId: CMS_PAGE_ID.pageOfferSCP,
    },
    offer_salary_account:{
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_SALARY_ACCOUNT,
        path: 'oferta-conta-salario',
        url:'oferta-conta-salario',
        cmsId: CMS_PAGE_ID.pageOfferSalaryAccount
    },
    recap:{
        flowName: COMMON_FLOW,
        stepId: STEP_ID.RECAP,
        path: 'recap',
        url:'recap',
        cmsId: CMS_PAGE_ID.pageRecap
    },
    offer_overdraft: {
        flowName: COMMON_FLOW,
        stepId: STEP_ID.OFFER_OVERDRAFT,
        path: "limite-em-conta",
        url: "limite-em-conta",
        cmsId: CMS_PAGE_ID.pageOfferOverdraft,
    },


};

export function getRoutesByStep(stepId: STEP_ID, flowName: any):IRoute[]{
    const result:IRoute[] = [];
    Object.entries(ROUTES).filter(
        route=>{
            const data:IRoute = route[1] as IRoute;
            return (Array.isArray(data.stepId) ? data.stepId.includes(stepId) :
                data.stepId === stepId) && data.flowName.find(element => element === flowName)
        }
    ).forEach(entry=>{
        const objKey = entry[0];
        const objValue = entry[1];
        const obj:IRoute = {};

        obj[objKey]=objValue;

        result.push(obj);
    });
    return result;
}

export interface IRoute {
    flowName?: string[],
    stepId?: STEP_ID;
    path?: string;
    url?: string;
    cmsId?: CMS_PAGE_ID

}
